import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const PricingPage = lazy(() => import('./pages/PricingPage'));
const FeaturesPage = lazy(() => import('./pages/FeaturesPage'));
const HotelEmailMarketingPage = lazy(() => import('./pages/HotelEmailMarketingPage'));
const SubjectScorerPage = lazy(() => import('./pages/SubjectScorerPage'));
const HelpCenterPage = lazy(() => import('./pages/HelpCenterPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const SignatureBuilderPage = lazy(() => import('./pages/SignatureBuilderPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const FreeToolsPage = lazy(() => import('./pages/FreeToolsPage'));
const UTMBuilderPage = lazy(() => import('./pages/UTMBuilderPage'));
const EmojiPickerPage = lazy(() => import('./pages/EmojiPickerPage'));
const ROICalculatorPage = lazy(() => import('./pages/ROICalculatorPage'));
const BookingPage = lazy(() => import('./pages/BookingPage'));

// Loading component for Suspense fallback
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '18px',
    color: '#393842'
  }}>
    Loading...
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/email-marketing-hotels" element={<HotelEmailMarketingPage />} />
            <Route path="/subject-scorer" element={<SubjectScorerPage />} />
            <Route path="/free-tools/subject-line-tester" element={<SubjectScorerPage />} />
            <Route path="/help-center" element={<HelpCenterPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/free-tools" element={<FreeToolsPage />} />
            <Route path="/free-tools/utm-builder" element={<UTMBuilderPage />} />
            <Route path="/free-tools/emoji-picker" element={<EmojiPickerPage />} />
            <Route path="/free-tools/email-signature-builder" element={<SignatureBuilderPage />} />
            <Route path="/free-tools/email-signature-maker" element={<SignatureBuilderPage />} />
            <Route path="/free-tools/roi-calculator" element={<ROICalculatorPage />} />
            <Route path="/booking" element={<BookingPage />} />
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

export default App; 